import { EntityApi } from "../../services/ApiPlatform";

export abstract class SkillApi extends EntityApi {
    protected static GET_COLLECTION = "/api/skills";

    protected static POST_COLLECTION = "/api/skills";

    protected static GET_ITEM = "/api/skills/{id}";

    protected static PUT_ITEM = "/api/skills/{id}";

    protected static PATCH_ITEM = "/api/skills/{id}";

    protected static DELETE_ITEM = "/api/skills/{id}";
}
